import * as React from 'react';
import './App.css';
import Layout from './components/Layout';
import Header from './components/Header';
import Footer from './components/Footer';
import Content from './components/Content';
import WelcomeModal from './components/WelcomeModal';
import Common from './util/common';
class App extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            listId: undefined
        };
        this.common = new Common();
        this.closeWelcomeModalHandler = () => { };
        this.loadListHandler = (listId) => {
            this.setState({ listId: listId });
            this.common.updateListCache(listId);
        };
        this.handlers = {
            closeWelcomeModal: this.closeWelcomeModalHandler,
            loadList: this.loadListHandler
        };
    }
    render() {
        let content = React.createElement(Content, { appState: Object.assign({}, this.state), handlers: this.handlers });
        if (!this.state.listId) {
            content = React.createElement(WelcomeModal, { handlers: this.handlers });
        }
        return (React.createElement("div", null,
            React.createElement(Layout, null,
                React.createElement(Header, { appState: Object.assign({}, this.state), handlers: this.handlers }),
                content,
                React.createElement(Footer, null))));
    }
}
export default App;
//# sourceMappingURL=App.js.map


// WEBPACK FOOTER //
// ./src/App.js